export default __webpack_public_path__ + "media/images/manual/joanr/01-9c479ab76d3fbd734cf1f7517a34b141.png";